import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {SubcategoryHistory} from '../models/subcategory-history';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubcategoryHistoryService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<SubcategoryHistory>('sbccv_subcategory_history', ref => ref
      .orderBy('date', 'asc')).snapshotChanges();
  }

  loadHistory () {
    return this.db.collection<any>('sbccv_subcategory_history', ref => ref
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc'))
      .get()
  }

  async loadAllHistories () {
    const array = [];
    const querySnapshot = await this.db.collection('sbccv_subcategory_history', ref => ref
      .orderBy("member_name"))
      .get()
      .toPromise();

    querySnapshot.forEach(async (doc: any) => {
      array.push({
        "id": doc.id,
        "date": this.formatDate(doc.data().date),
        "member_id": doc.data().member_id,
        "member_name": doc.data().member_name,
        "category_id": doc.data().subcategory_id,
        "category_name": doc.data().subcategory_name
      })
    })

    return array;

  }

  formatDate (date: any) {
    if (date) {
      let d: any = date
      date = new Date(d.seconds * 1000)
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy

    } else {
      return ""
    }
  }

  selectByMemberId (memberId: string) {
    return this.db.collection<SubcategoryHistory>('sbccv_subcategory_history', ref => ref
      .where("member_id", "==", memberId)
      .orderBy('date', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
            date: data.date?.toDate() || null
          } as SubcategoryHistory;
        }))
      );
  }

  insert (entity: SubcategoryHistory) {
    return this.db.collection('sbccv_subcategory_history').add(Object.assign({}, entity));
  }

  update (entity: SubcategoryHistory) {
    return this.db.collection('sbccv_subcategory_history').doc(entity.id).set(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_subcategory_history').doc(entity_id).delete();
  }

  createSubcategoryHistory (data) {
    const entity = new SubcategoryHistory()
    entity.id = data.id;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.date = data.date;
    entity.subcategory_id = data.subcategory_id;
    entity.subcategory_name = data.subcategory_name;
    entity.subcategory_annuity = data.subcategory_annuity ? true : false;
    entity.annuity_from = data.annuity_from;

    return entity
  }

}


